import React from "react";
import styled from "styled-components";
import DotsLine from "components/common/view_util/DotsLine";
import { usePageNumFromQuery } from "hooks/hook_util/path_query/usePageNumFromQuery";
import { useUnitFromPathSlug } from "hooks/citajteo/dl_unit/path_query/useUnitFromPathSlug";
import UnitScanNumNav from "components/common/dl_unit/navigation/UnitScanNumNav";
import { useSearchParams } from "react-router-dom";
import UnitScanLiNav from "components/common/dl_unit/navigation/UnitScanNumNav/UnitScanLiNav";

export default function UnitScanNavigation() {
  const page = usePageNumFromQuery();
  const unit = useUnitFromPathSlug();
  const [searchParams, setSearchParams] = useSearchParams();

  if (unit === null) {
    return <></>;
  }

  const unitScanIndSet = (ind: number) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("page", ind + 1 + "");
    setSearchParams(newSearchParams);
  };

  return (
    <Div>
      <DivTitle>{unit.unitTitleGet()}</DivTitle>
      <UnitScanLiNav
        page={page}
        scansTotal={unit.scans.length}
        numClickNav={unitScanIndSet}
      />
      <DivCurrentTotalNum>
        {page} / {unit.scans.length}
      </DivCurrentTotalNum>
      <UnitScanNumNav
        page={page}
        scansTotal={unit.scans.length}
        onNumClick={unitScanIndSet}
      />
      <DotsLine />
    </Div>
  );
}

const Div = styled.div`
  margin-top: 0;
  color: darkgray;
  font-weight: 200;
  font-family: verdana;
  font-size: 14px;
  width: 100%;
`;

const DivTitle = styled.div`
  margin-top: 0.5em;
  color: black;
  line-height: 1.2em;
`;

const DivCurrentTotalNum = styled.div`
  margin-top: 0.5em;
`;
